// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const BottomNavWrapper = registerClientReference(
    function() { throw new Error("Attempted to call BottomNavWrapper() from the server but BottomNavWrapper is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/the-50-dollar-app-audit/src/components/bottom-nav-wrapper.tsx",
    "BottomNavWrapper",
);
